module.exports = __webpack_public_path__ + "img/block.a6a9eb9b.svg";